var _linearGradient, _path, _linearGradient2, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgDone = function SvgDone(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 64 64"
  }, props), _linearGradient || (_linearGradient = /*#__PURE__*/React.createElement("linearGradient", {
    id: "done_svg__a",
    x1: 32,
    x2: 32,
    y1: 12.664,
    y2: 52.422,
    gradientUnits: "userSpaceOnUse",
    spreadMethod: "reflect"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#1A6DFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C822FF"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "url(#done_svg__a)",
    d: "M24.982 51a5.03 5.03 0 0 1-3.524-1.429L6.888 35.364C6.315 34.806 6 34.061 6 33.268s.315-1.538.889-2.097l2.82-2.75a3.046 3.046 0 0 1 4.228.001l10.259 10.003c.395.385 1.058.38 1.446-.012l24.341-24.526a3.047 3.047 0 0 1 4.228-.068l2.867 2.705c.582.55.91 1.29.923 2.083a2.9 2.9 0 0 1-.854 2.109L28.565 49.514A5.03 5.03 0 0 1 24.982 51m-13.16-21.436c-.26 0-.52.097-.717.29l-2.82 2.75c-.184.179-.285.414-.285.664s.102.485.285.664L22.854 48.14a3.057 3.057 0 0 0 4.291-.034l28.581-28.798a.92.92 0 0 0-.023-1.329l-2.867-2.705a1.034 1.034 0 0 0-1.435.022l-24.34 24.527a3.04 3.04 0 0 1-4.263.034L12.54 29.853a1.02 1.02 0 0 0-.718-.289"
  })), _linearGradient2 || (_linearGradient2 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "done_svg__b",
    x1: 32.013,
    x2: 32.013,
    y1: 16.83,
    y2: 47.526,
    gradientUnits: "userSpaceOnUse",
    spreadMethod: "reflect"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#8ab4ff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#e492ff"
  }))), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#done_svg__b)",
    d: "M24.977 46.609c-.489 0-.98-.181-1.368-.544L10.318 33.603l1.367-1.459 13.292 12.461L52.293 17.29l1.414 1.414-27.316 27.315c-.391.392-.902.59-1.414.59"
  })));
};
export default SvgDone;